export enum FlowchartElementType {
  FlowchartStartNode = 0,
  FlowchartAction = 1,
  FlowchartDecisionNode = 2,
  FlowchartCondition = 3,
  FlowchartSelectionBehavior = 4,
  FlowchartLink = 5,
  FlowchartTextBlock = 6,
  FlowchartSubflow = 7,
  FlowchartContainer = 8,
}
